import React, { CSSProperties, FC } from 'react'
import styled from 'styled-components'
import { ThemeColor } from 'types/color'
import { Icon } from 'components/base-ui'
import { onClick } from 'helpers/fastClick'

interface BtnBackProps {
  className?: string
  enableFastClick?: boolean
  onClick: (e: any) => void
  color?: ThemeColor
  bold?: boolean
  lg?: boolean
  style?: CSSProperties
}

const BtnBack: FC<BtnBackProps> = ({
  onClick: btnOnClick,
  enableFastClick = false,
  color = ThemeColor.primary,
  bold = false,
  className = '',
  lg = false,
  style = {},
}) => {
  const _className = `${className ? `${className} ` : ''} button`
  let clickObj = {}
  const iconName = bold ? 'arrow-left-bold' : 'arrow-left'

  if (btnOnClick) {
    clickObj = enableFastClick ? { ...onClick((e) => btnOnClick(e)) } : { onClick: btnOnClick }
  }

  return (
    <BtnBackStyled data-testid="btn-back" color={color} lg={lg} className={_className} {...clickObj} style={style}>
      <Icon name={iconName} />
    </BtnBackStyled>
  )
}

export default BtnBack

const BtnBackStyled = styled.div<{ color: ThemeColor; lg: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.05), 0px 1px 6px rgba(0, 0, 0, 0.1);
  background-color: white;
  transition: 0.6s;

  i {
    font-size: 17px;
    color: ${({ color, theme }) => (color === ThemeColor.primary ? theme.colors.primary : theme.colors.secondary)};
    transition: 0.6s;
  }

  ${({ lg }) =>
    lg
      ? `
    width: 56px;
    height: 56px;
  `
      : ''}

  .touch &.touch {
    transition: 0s;
    background-color: ${({ color, theme }) =>
      color === ThemeColor.primary ? theme.colors.primary : theme.colors.secondary};
    transform: scale(1.05);

    i {
      transition: 0s;
      color: white;
    }
  }
`
